<template>
    <page>
        <module enable-flex ref="view">
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
                    <c-form-item type="select" label="代理等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
                    <c-form-item type="select" label="成长等级" name="growth_level" options="GROWTH_LEVEL_AUTH" v-if="systemConfig.growth_enable == 'ON'"></c-form-item>
                    <c-form-item type="checkbox" label="会员状态" name="state" :options="stateType"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_platform_user_edit" color="sys" icon="add"  @click="editUser()">新增会员</c-button>
                <c-button power="b_platform_user_edit" @click="$refs.excelImport.open()" icon="upload" color="black">导入会员</c-button>
                <c-button color="black" power="b_platform_set_user_level" v-if="systemConfig.share_enable == 'OFF'"  hollow @click="setUserLevel(1)">设置会员等级</c-button>
                <c-button color="black" power="b_platform_set_salesman" v-if="systemConfig.salesman_enable == 'ON'"  hollow @click="setUserSalesman(1)">设置业务员</c-button>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>
                <!--              <c-button color="red" v-if="userInfo.id == 1"  @click="resetBranchRef()">重置关系树</c-button>-->
                <!--右侧通用菜单-->
                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">
                        编辑导出列
                    </c-button>
                </template>
            </m-operate>

            <c-table ref="table">
                <c-table-column type="selector" ></c-table-column>

                <c-table-column
                        label="会员头像/昵称"
                        name="head_photo"
                        width="200"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                            <div>
                                <span>{{data.nick_name}}</span></br>
                            </div>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="手机号"
                        name="user_manage_mobilephone"
                        width="110"
                >
                    <template v-slot="{data}">
                        <span>{{data.user_manage_mobilephone||'-'}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="成长等级"
                        name="growth_level_name"
                        v-if="systemConfig.growth_enable == 'ON'"
                        width="90"
                >
                    <template v-slot="{data}">
                        <span v-if="data.growth_level_name && data.user_level == -99" style="color: blue">{{data.growth_level_name}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="成长值"
                        name="growth_value"
                        v-if="systemConfig.growth_enable == 'ON'"
                        width="70"
                >
                    <template v-slot="{data}">
                        <span v-if="data.user_level == -99" style="color: blue">{{data.growth_value}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>
				
				<c-table-column
				        label="签到次数"
				        name="singin_count"
				        width="80"
				>
					<template v-slot="{data}">
                        <a v-if="data.user_level == -99 && data.singin_count > 0" style="color: blue" title="签到次数" @click="showSinginRecord(data)">
							{{data.singin_count}}&nbsp;&nbsp;
                        </a>
						<span v-else-if="data.user_level == -99 && data.singin_count == 0">0</span>
                        <span v-else>-</span>
					</template>
				</c-table-column>

                <c-table-column
                        label="代理等级"
                        name="user_level_name"
                        width="90"
                >
                    <template v-slot="{data}">
                        <span v-if="data.user_level_name && data.user_level_name!='' && data.user_level > 0" style="color:blue">{{data.user_level_name}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="邀请人头像/手机/昵称"
                        name="head_photo"
                        v-if="systemConfig.share_enable == 'ON'"
                        width="200"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross" v-if="data.platform_user_id > 0">
                            <c-image :src="data.share_user_head_photo" preview size="38" style="margin-right: 10px;"></c-image>
                            <div>
                                <span>{{data.share_user_manage_mobilephone}}</span></br>
                                <span>{{data.share_user_nick_name}}</span>
                            </div>
                        </div>
                        <span v-else>--</span>
                    </template>
                </c-table-column>
				
                <c-table-column
                        label="业务员"
                        name="salesman_name"
                        v-if="systemConfig.salesman_enable == 'ON'"
                >
                    <template v-slot="{data}">
                        <span v-if="data.salesman_name && data.salesman_name!=''">{{data.salesman_name}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="业绩数量"
                        name="performance_count"
                        width="100"
                >
                    <template v-slot="{data}">
                        <a v-if="data.performance_count > 0" style="color: blue" title="已结算业绩数量" @click="showPerformanceRecord(data,2)">{{data.performance_count}}</a>
                        <span v-else style="color: gray" title="已结算业绩数量">0</span>
                        /&nbsp;
                        <a v-if="data.unsettle_performance_count > 0" style="color: blue" title="待结算业绩数量" @click="showPerformanceRecord(data,1)">{{data.unsettle_performance_count}}</a>
                        <span v-else style="color: gray" title="待结算业绩数量">0</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="下单数量"
                        name="order_count"
                        width="80"
                >
                </c-table-column>
				
                <c-table-column
                        label="退款单数"
                        name="refund_count"
                        width="80"
                >
                </c-table-column>

                <c-table-column
                        label="货款余额(元)"
                        name="account_balance"
                        width="100"
                        v-if="systemConfig.account_balance_enabled == 'ON'"
                >
                    <template v-slot="{data}">
                        ￥{{data.account_balance}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="积分"
                        name="points"
                        width="80"
                        v-if="systemConfig.points_system == 'ON'"
                >
                </c-table-column>

                <c-table-column
                        label="会员ID"
                        name="platform_user_id"
                >
                </c-table-column>

                <c-table-column
                        label="注册时间"
                        name="create_date"
                        width="150"
                >
                </c-table-column>

                <c-table-column
                        label="注册来源"
                        name="user_resource"
                        width="100"
                >
                    <template v-slot="{data}">
                        {{userResourceMap[data.user_resource]}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="状态"
                        name="state"
                        width="50"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 1" style="color:darkgreen">启用</span>
                        <span v-if="data.state == 2" style="color:red">禁用</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="店铺开通状态"
                        name="shop_id"
                        width="110"
                        v-if="systemConfig.oms_seller_shop_enabled == 'ON'"
                >
                    <template v-slot="{data}">
                        <span v-if="data.shop_id == 0" style="color:#bbb">未开通</span>
                        <span v-else style="color:darkgreen">已开通</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="实名认证"
                        name="auth_state"
                        width="80"
                        v-if="systemConfig.f_config_user_auth_enabled =='ON'"
                >
                    <template v-slot="{data}">
                        <span v-if="data.auth_state == -1" style="color:#bbb">未认证</span>
                        <span v-if="data.auth_state == 0" style="color:blue">审核中</span>
                        <span v-if="data.auth_state == 1" style="color:darkgreen">认证通过</span>
                        <span v-if="data.auth_state == 2" style="color:red">认证驳回</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="授信额度(元)"
                        name="credit_money"
                        width="100"
                        v-if="systemConfig.credit_pay == 'ON'"
                >
                    <template v-slot="{data}">
						<span v-if="data.credit_money > 0">
							￥{{data.credit_money}}
						</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="授信余额(元)"
                        name="credit_money"
                        width="100"
                        v-if="systemConfig.credit_pay == 'ON'"
                >
                    <template v-slot="{data}">
						<span v-if="data.credit_money > 0">
							￥{{data.credit_money - data.credit_money_use}}
						</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="打卡总数"
                        name="singin_record_count"
                        width="100"
                        v-if="systemConfig.credit_pay == 'ON'"
                >
                    <template v-slot="{data}">
						<span v-if="data.singin_record_count > 0">

						</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template v-slot="{data}">
                        <c-table-button power="m_platform_user" @click="detail(data)">详情</c-table-button>
                        <c-table-button power="m_platform_user" v-if="data.user_level == -99 && data.singin_count > 0" @click="showSinginRecord(data)">签到记录</c-table-button>
                        <c-table-button power="b_platform_user_state" v-if="data.state == 2 && data.platform_user_id > 0"  @click="updateState(1,data)">启用</c-table-button>
                        <c-table-button power="b_platform_user_state" v-if="data.state == 1 && data.platform_user_id > 0"  @click="updateState(2,data)">禁用</c-table-button>
                        <c-table-button power="b_platform_user_shop" v-if="systemConfig.oms_seller_shop_enabled == 'ON' && data.shop_id == 0 && data.platform_user_id > 0" @click="openShop(data)">开通店铺</c-table-button>
                        <c-table-button power="b_member_user_change" v-if="systemConfig.share_enable == 'ON' && data.platform_user_id > 0" @click="$refs.memberUpgrade.open(data)">会员调整</c-table-button>
                        <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0" @click="showMemberUpgradeRecord(data)">调整记录</c-table-button>
                        <c-table-button power="m_platform_user" v-if="data.platform_user_id > 0" @click="showMemberParentList(data)">查看邀请链路</c-table-button>
                        <c-table-button power="b_platform_credit_stop" v-if="systemConfig.credit_pay == 'ON' && data.credit_money > 0 && data.platform_user_id > 0" @click="creditStop(data)">停用授信</c-table-button>
                        <c-table-button power="m_special_price" v-if="data.platform_user_id > 0" @click="showSpecialPriceConfig(data)">特殊价配置</c-table-button>
                        <c-table-button power="b_member_edit_cloud_stock" v-if="systemConfig.cloud_stock == 'ON' && data.user_level >= systemConfig.cloud_stock_level"
                                        @click="setCloudStock(data)">云仓库存</c-table-button>
<!--
                        <c-table-button power="b_platform_points_edit" v-if="data.platform_user_id > 0" @click="$refs.memberPointsEdit.open(data)">积分补扣</c-table-button>
-->
                    </template>
                </c-table-column>
            </c-table>

            <c-dialog ref="editUserDialog" :title="editState ? '编辑会员' : '新增会员'" width="750" @resolve="submitEditUser">
                <c-form ref="edit_form">
                    <c-form-item type="hidden" name="id"></c-form-item>
                    <c-form-item type="number" decimal="0"  label="代理手机号" maxlength="11" name="mobile_phone" required word="请输入11位手机号"></c-form-item>
                    <!--					<c-form-item type="input" label="会员名" name="login_name" maxlength="16" word="用于登录平台，登录名只允许包含中文、英文字母、数字、下划线，长度在1-16位"></c-form-item>-->
                    <c-form-item type="input" label="代理昵称" name="nick_name" maxlength="30" word="不设置将由系统自动生成，昵称只允许输入中文、英文最大长度为30个字符"></c-form-item>
                </c-form>
            </c-dialog>

            <c-dialog ref="levelEdit" title="设置会员等级" width="500" height="250" @resolve="setLevelHandle">
                <div class="tag-list" style="padding: 20px;">
                    <c-radio-group v-model="current_user_level">
                        <c-radio v-for="(item, i) in user_level_list" :key="i" :value="item.value" style="margin-bottom: 20px;">{{item.name}}</c-radio>
                    </c-radio-group>
                </div>
            </c-dialog>

            <c-dialog ref="salesmanEdit" title="设置业务员" width="500" height="250" @resolve="setSalesmanHandle">
                <div class="tag-list" style="padding: 20px;">
                    <c-radio-group v-model="current_salesman">
                        <c-radio v-for="(item, i) in salesman_list" :key="i" :value="item.value" style="margin-bottom: 20px;">{{item.name}}</c-radio>
                    </c-radio-group>
                </div>
            </c-dialog>

            <c-dialog ref="shopEdit" title="开通分销商店铺" width="600" @resolve="submitShop">
                <c-form ref="shopForm">
                    <c-form title="基本信息">
                        <c-form-item type="input" label="经销商名称" name="company_name" maxlength="30" required></c-form-item>
                        <c-form-item type="input" label="店铺名称" name="shop_name" maxlength="50" required></c-form-item>
                        <c-form-item type="hidden" name="platform_user_id"></c-form-item>
                    </c-form>
                    <c-form title="配置信息">
                        <c-form-item type="region" label="默认发货地"
                                     province-name="delivery_province_id"
                                     city-name="delivery_city_id"
                                     county-name="delivery_county_id"
                                     required></c-form-item>
                        <c-form-item type="select" label="分销商角色" name="auth_id" options="SELLER_AUTH" required></c-form-item>
                        <c-form-item type="radio" label="清分方式" name="liquidation_type" :options="liquidationType" required></c-form-item>
                        <c-form-item type="number" label="" name="liquidation_date" :limit="[0,100]" word="天"></c-form-item>
                    </c-form>
                </c-form>
            </c-dialog>
            <!--云仓库存编辑-->
            <c-dialog ref="stockEdit" :title="stockEditTitle" width="1000" height="620" enable-flex  @resolve="setStockHandle">
                <m-search ref="stockSearch" @search="stockSearchHandle">
                    <c-form ref="stockForm" inline>
                        <c-form-item type="input" label="商品信息" name="product_info" placeholder="模糊匹配货号、名称"></c-form-item>
                        <c-form-item type="input" label="商品规格" name="product_sku_spec" placeholder="模糊匹配商品规格"></c-form-item>
                        <c-form-item type="input" label="SKU编码" name="product_sku_code" placeholder="精确匹配"></c-form-item>
                        <c-form-item type="checkbox" label="" name="isStock" :options="[{name: '有库存',value: 1}]"></c-form-item>
                    </c-form>
                </m-search>
                <c-table ref="stockTable" height="500">
                    <c-table-column
                            label="商品信息"
                            name="product_name"
                            width="300"
                    >
                        <template v-slot="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="规格名称"
                            name="product_sku_spec"
                            width="120"
                    ></c-table-column>

                    <c-table-column
                            label="SKU编码"
                            name="product_sku_code"
                            width="150"
                    ></c-table-column>

                    <c-table-column
                            label="当前库存"
                            name="product_count"
                            width="70"
                    >
                    </c-table-column>

                    <c-table-column
                            width="100"
                    >
                        <template slot="head">
                            <div class="flex-center-cross">
                                <span>增减库存</span>
                                <a style="margin-left: 10px;" @click="$refs.batchStockDialog.open()"><i class="tf tf-edit"></i></a>
                            </div>
                        </template>
                        <template v-slot="{data}">
                            <c-input v-model="data.revise_stock" type="number" :limit="[-data.product_count, 9999]"></c-input>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="调整后库存"
                            name="new_product_count"
                            width="120"
                    >
                        <template v-slot="{data}">
                            {{parseInt(data.product_count) + (parseInt(data.revise_stock) || 0)}}
                        </template>
                    </c-table-column>
                </c-table>
            </c-dialog>

            <c-dialog ref="batchStockDialog" title="批量增/减库存" width="400" height="140" @resolve="batchSetStock">
                <c-form ref="batchStockForm">
                    <c-form-item type="number" label="增/减库存" name="value"></c-form-item>
                </c-form>
            </c-dialog>
        </module>
        <pop-special-price-list ref="popSpecialPriceList"></pop-special-price-list>
        <member-upgrade ref="memberUpgrade" @resolve="$refs.table.update()"></member-upgrade>
        <member-points-edit ref="memberPointsEdit" @resolve="$refs.table.update()"></member-points-edit>
        <member-upgrade-record ref="memberUpgradeRecord"></member-upgrade-record>
        <user-performance-record ref="userPerformanceRecord"></user-performance-record>
        <member-parent-list ref="memberParentList"></member-parent-list>
        <user-singin-record ref="userSinginRecord"></user-singin-record>
        <excel-import ref="excelImport" :work-type="importWorkType" @resolve="$refs.table.update();"></excel-import>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import popSpecialPriceList from '@/components/service/pop_special_price_list.vue'
import memberUpgrade from "@/components/service/member_user_upgrade.vue";
import memberPointsEdit from "@/components/service/member_user_points_edit.vue";
import memberUpgradeRecord from "@/components/service/member_user_upgrade_record.vue";
import userPerformanceRecord from "@/components/service/platform_user_performance_record.vue";
import memberParentList from "@/components/service/member_parent_list.vue";
import excelImport from "@/components/service/import_excel_data.vue";
import userSinginRecord from "@/components/service/platform_user_singin_record.vue";
import productInfo from "@/components/public/product_info.vue";

export default {
    name: 'm_platform_user',
    components: {
        productInfo,
        excelImport,
        popSpecialPriceList,
        memberUpgrade,
        memberPointsEdit,
        memberUpgradeRecord,
        userPerformanceRecord,
        memberParentList,
        userSinginRecord
    },
    data() {
        return {
            workType:12,
            importWorkType:903,     //批量导入会员 code
            searchParams:{},
            editState: false,   //编辑或是新增  true=编辑  false=新增
            userResourceMap: {
                'OMS':'管理后台',
                'PC':'PC电脑',
                'IOS':'苹果APP',
                'ANDROID':'安卓APP',
                'MINI':'微信小程序',
                'RETAIL_MINI':'微信小程序',
                'BARGAIN':'砍价页',
                'H5':'H5页'
            },
            stateType:[
                {
                    name:'启用',
                    value:1
                },{
                    name:'禁用',
                    value:2
                }
            ],
            liquidationType:[
                {
                    name:'发货后',
                    value:1
                }, {
                    name:'确认收货后',
                    value:2
                }
            ],
            current_user_level:-1,//当前选中的等级
            user_level_list:[],//会员等级列表
            current_salesman:'',//当前选中的业务员
            salesman_list:[],//业务员列表
            stockEditTitle:'云仓库存'
        }
    },
    computed: {
        ...mapState(['systemConfig', 'userInfo']),
    },
    mounted() {
        this.$refs.search.search();
    },

    methods: {
        selectHandle(list, ref, key) {
            var tran_share_user_name = "--";
            var share_user_id = -1;
            if (list && list[0]) {
                console.log(list[0]);
                tran_share_user_name = (list[0].nick_name || "--") + "【" + list[0].user_manage_mobilephone || "--" + "】";
                share_user_id = list[0].platform_user_id || -1;
            }
            this.$refs.memberForm.set({
                tran_share_user_name: tran_share_user_name,
                share_user_id: share_user_id,
            });
        },

        searchHandle(data) {
            data.query_type = 1;
            this.$refs.table.load({
                url: '/platform_user/list',
                data
            });
            this.searchParams = data||{};
        },

        //查询会员详情
        detail(val) {
            this.navigateTo({
                path: '/member_detail/' + val.platform_user_id,
            });
        },

        //更新会员状态
        updateState(type, val) {
            this.$confirm({
                text: '确定要' + (type == 1 ? '启用' : '禁用') + '【' + val.user_manage_mobilephone + '】吗？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/platform_user/update_state',
                        data: {platform_user_id: val.platform_user_id, state: type},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        /**打开 新增/编辑 弹窗**/
        editUser() {
            //清空表单数据
            this.$refs.edit_form.clear();
            this.editState = false;//新增
            this.$refs.editUserDialog.open();
            this.$refs.edit_form.set({});
        },

        /**提交修改**/
        submitEditUser(stop) {
            stop();
            this.$refs.edit_form.submit({
                url: '/platform_user/add',
                rule: {
                    mobile_phone: '请输入会员手机号'
                },
                success: (data, res) => {
                    //关闭弹窗
                    this.$refs.editUserDialog.close();
                    this.$message({
                        text: '操作成功！'
                    });
                    // 清空表单数据
                    this.$refs.edit_form.clear();
                    this.$refs.search.search();
                }
            });
        },

        /***批量修改会员等级**/
        setUserLevel(batch, item) {
            this.userIds = [];
            if (batch == 1) {//批量设置
                var list = this.$refs.table.getRow('selected');
                if (!list.length) {
                    this.$message({
                        text: '请选择要操作的会员'
                    });
                    return;
                }
                this.userIds = Array.from(list, item => {
                    return item.data.platform_user_id;
                })
            } else {//单个设置
                this.userIds.push(item.platform_user_id);
            }
            this.request({
                url: '/user_level/options',
                data: {},
                loading: true,
                success: data => {
                    this.user_level_list = data;
                    this.$nextTick(() => {
                        this.current_user_level = -1;
                    });
                    this.$refs.levelEdit.open();
                }
            });
        },

        //设置会员等级
        setLevelHandle(stop) {
            stop();
            if (this.current_user_level == -1) {
                this.$message({
                    text: '请选择会员等级'
                });
                return;
            }
            this.request({
                url: '/platform_user/set_level',
                data: {
                    user_ids: this.userIds,
                    user_level: this.current_user_level
                },
                loading: true,
                success: data => {
                    this.$message({
                        text: '设置会员等级请求发送成功，调整结果可能稍有延迟！'
                    });
                    this.$refs.levelEdit.close();
                    //延迟刷新页面
                    setTimeout(() => {
                        this.$refs.table.update();
                    }, 1000);
                }
            });
        },

        /***批量修改会员业务员**/
        setUserSalesman(batch, item) {
            this.userIds = [];
            if (batch == 1) {//批量设置
                var list = this.$refs.table.getRow('selected');
                if (!list.length) {
                    this.$message({
                        text: '请选择要操作的会员'
                    });
                    return;
                }
                this.userIds = Array.from(list, item => {
                    return item.data.platform_user_id;
                })
            } else {//单个设置
                this.userIds.push(item.platform_user_id);
            }
            this.request({
                url: '/sys_user/options',
                data: {},
                loading: true,
                success: data => {
                    this.salesman_list = data;
                    this.$nextTick(() => {
                        this.current_salesman = '';
                    });
                    this.$refs.salesmanEdit.open();
                }
            });
        },

        //设置会员业务员
        setSalesmanHandle(stop) {
            stop();
            if (!this.current_salesman) {
                this.$message({
                    text: '请选择业务员'
                });
                return;
            }
            this.request({
                url: '/platform_user/set_salesman',
                data: {
                    user_ids: this.userIds,
                    salesman_id: this.current_salesman
                },
                loading: true,
                success: data => {
                    this.$message({
                        text: '设置业务员成功'
                    });
                    this.$refs.salesmanEdit.close();
                    //刷新页面
                    this.$refs.table.update();
                }
            });
        },

        //开通店铺
        openShop(val) {
            this.$refs.shopForm.clear();
            val.company_name = val.nick_name;
            val.shop_name = val.nick_name + '的小店';
            this.$refs.shopForm.set(val);
            this.$refs.shopEdit.open();
        },

        //提交 开通分销商店铺 数据
        submitShop(stop) {
            stop();
            this.$refs.shopForm.submit({
                url: '/platform_user/openShop',
                rule: {
                    company_name: '请输入经销商名称',
                    shop_name: '请填写店铺名称',
                    delivery_city_id: '请选择发货地',
                    auth_id: '请选择分销商家角色',
                    liquidation_type: '请选择清分方式',
                    liquidation_date: '请输入清分延迟天数'
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res, msg) => {
                    this.$confirm({
                        icon: 'success',
                        text: msg,  // 提示内容,
                        buttonName: '确定',  // 确定按钮文字
                        cancelButton: false  // 是否显示取消按钮
                    });
                    this.$refs.table.update();
                    this.$refs.shopEdit.close();
                }
            });
        },
        /**********停用授信**************/
        creditStop(data) {
            this.$confirm({
                text: '停用后，会员的授信额度将被清空，是否确定要停用会员【' + data.user_manage_mobilephone + '(' + data.nick_name + ')】的授信？',
                resolve: () => {
                    this.request({
                        url: '/platform_user/credit/stop',
                        data: {
                            platform_user_id: data.platform_user_id,
                        },
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功'
                            });
                            this.$refs.table.update();
                        }
                    });
                }
            });
        },

        /**同步导出数据*/
        syncExport(){
            var selectDatas = this.$refs.table.getRow('selected');
            var ids = [];
            if (selectDatas.length && selectDatas.length>0) {
                ids = Array.from(selectDatas, item => item.data.platform_user_id);
            }
            this.export(this.workType,this.searchParams,ids);
        },

        /**********重置关系树**************/
        resetBranchRef() {
            this.$confirm({
                text: '重置关系树将根据代理表中的邀请人重新生成邀请关系树，是否确认重置？',
                buttonName: '确认重置',
                resolve: () => {
                    this.request({
                        url: '/platform_user//init/branch',
                        data: {},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '重置成功'
                            });
                            this.$refs.table.update();
                        }
                    });
                }
            });
        },

        /*************显示代理特殊价配置**********/
        showSpecialPriceConfig(data){
            var title = '代理【'+data.user_manage_mobilephone+'('+(data.nick_name||'--')+')】特殊价信息';
            this.$refs.popSpecialPriceList.open({
                platform_user_id:data.platform_user_id,
                title:title
            });
        },

        /*************显示代理调整日志配置**********/
        showMemberUpgradeRecord(data){
            var title = '会员【'+data.user_manage_mobilephone+'('+(data.nick_name||'--')+')】调整记录';
            this.$refs.memberUpgradeRecord.open({
                platform_user_id:data.platform_user_id,
                title:title
            });
        },
        /*************查看会员邀请链路**********/
        showMemberParentList(data){
            var title = '会员【'+data.user_manage_mobilephone+'('+(data.nick_name||'--')+')】邀请链路表';
            this.$refs.memberParentList.open({
                platform_user_id:data.platform_user_id,
                title:title
            });
        },

        /*************显示用户业绩明细列表**********/
        /**
         *
         * @param data      用户信息
         * @param state     业绩结算状态 0：取消清分、1：待清分，2：已经清分
         */
        showPerformanceRecord(data,state){
            var title = '会员【'+data.user_manage_mobilephone+'('+(data.nick_name||'--')+')】【'+(state==2?'已清分':'待清分')+'】业绩数据';
            this.$refs.userPerformanceRecord.open({
                platform_user_id:data.platform_user_id,
                states:[state],
                title:title
            });
        },

        /*************显示用户签到记录列表**********/
        /**
         * @param data      用户信息
         */
        showSinginRecord(data){
            var title = '会员【'+data.user_manage_mobilephone+'('+(data.nick_name||'--')+')】签到记录数据';
            this.$refs.userSinginRecord.open({
                platform_user_id:data.platform_user_id,
                title:title
            });
        },
        //云仓库存弹窗
        setCloudStock(item) {
            this._setUserId = item.platform_user_id;
            this.stockEditTitle = '代理【'+item.user_manage_mobilephone+'】';
            if (item.nick_name){
                this.stockEditTitle += '('+item.nick_name+')';
            }
            this.stockEditTitle += ' - 云仓库存信息';
            this.$refs.stockEdit.open();
            this.$refs.stockForm.clear();
            this.$refs.stockForm.set({isStock: [1]});
            this.stockSearchHandle({isStock: [1]});
        },

        //查询云仓库存
        stockSearchHandle(data) {
            data.platform_user_id = this._setUserId;
            this.$refs.stockTable.load({
                url: '/cloud/stock/list',
                data
            });
        },
        //批量设置云仓库存
        batchSetStock() {
            let n = parseFloat(this.$refs.batchStockForm.serialize().value);
            if (n == n) {
                this.$refs.stockTable.getRow().forEach(item => {
                    item.data.revise_stock = n;
                })
            }
            this.$refs.batchStockForm.clear();
        },
        //提交云仓库存设置数据
        setStockHandle(stop) {
            stop();
            var stockList = this.$refs.stockTable.getRow().filter(item => ((parseInt(item.data.revise_stock) || 0) !=0));
            if(stockList.length ==0){
                this.$message({
                    text: '您未做任何库存变更！'
                });
                return;
            }
            this.request({
                url: '/cloud/stock/edit',
                data: {
                    platform_user_id: this._setUserId,
                    product_sku_stock_list: Array.from(stockList, item => {
                        return {
                            product_id: item.data.product_id,
                            product_sku: item.data.product_sku,
                            product_count: parseInt(item.data.product_count) + (parseInt(item.data.revise_stock) || 0)
                        }
                    })
                },
                loading: true,
                success: data => {
                    this.$message({
                        text: '云仓库存调整成功',
                        icon: 'success'
                    });
                    //刷新列表
                    this.$refs.stockTable.update();
                }
            });
        },
    }
}
</script>